import React from 'react';
import styled from 'styled-components';
import { COLORS } from 'styles/variables';

const BadgeWrapper = styled.div<{ size?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  right: 0;
  top: 0;
  transform: translateY(-90%) translateX(150%);
  width: ${({ size }) => size || '2rem'};
  height: ${({ size }) => size || '2rem'};
  font-size: 1.1rem;
  position: absolute;
  border-radius: 9999px;
  color: white;
  background-color: ${COLORS.RED_6};
`;

export default function Badge({
  children,
  size
}: {
  children: React.ReactNode;
  size?: string;
}) {
  return <BadgeWrapper size={size}>{children}</BadgeWrapper>;
}
